export const STR = `<b>Hello,</b><b><p>dolly</p></b> shit`;
export const STR2 = `<!DOCTYPE HTML>

<html xmlns="http://www.w3.org/1999/xhtml" lang="en-US" xml:lang="en-US">

<head>

    <title>In Re: M/s. G.B. Agro Industries,</title>
    <link rel="stylesheet" type="text/css" href="/library/style_sheet_print_page.css">

    <style type="text/css">
        <!--
        .style1 {
            color: #0000FF
        }
        -->
    </style>
</head>

<body onLoad="">


    <p align="center">
        <strong>2021 (10) TMI 59 - APPELLATE AUTHORITY FOR ADVANCE RULING, GUJARAT</strong>
    </p>






    <h4 align="center">IN RE: M/S. G.B. AGRO INDUSTRIES,</h4>


    <p align="center">GUJ/GAAAR/APPEAL/2021/25 </p>

    <p align="center"><strong>Dated: - 20 July 2021</strong></p>


    <span align="justify">
        <p><strong>Classification <br> of goods - HSN Code - Organic manure - classified under Chapter subheading No.31059090
                on which GST liability was 5% or otherwise - Bio-fertilizers - classified under Chapter sub-heading
                No.30029030 on which GST liability was 12% or otherwise - Nitrogeneous mixture fertilizers - classified
                under Chapter sub-heading No.31029090 on which GST liability was 5% or otherwise? - Mixture of
                fertilizers - classified under Chapter sub-heading No.31059090 on which GST liability was 5% or
                otherwise? - </strong>HELD THAT:- From the submission of the appellant, especially the composition of
            the inputs contained in their products i.e. &lsquo;Bio-fertilizers&rsquo; and comparing the same to the
            definitions of &lsquo;Bio-fertilizers&rsquo;, it does not appear to meet the criteria of
            &lsquo;bio-fertilizer&rsquo; particularly because &lsquo;Organic manure&rsquo; (main source of which is
            animal waste) is a major input constituting 50% of the mixture whereas Bio culture contained therein is only
            2%. Further, the appellant themselves have submitted that they are presently manufacturing only two types of
            &lsquo;Bio-fertilizers&rsquo; namely Phosphate Solubilising Bacteria and Potassium mobilising
            Bio-fertilizers. Hence, it can be presumed that the composition of inputs submitted by them pertains to
            these two products only and therefore the classification to be decided is in respect of these two products
            only - in the instant case, the two products i.e. Phosphate Solubilising Bacteria and Potassium mobilising
            Bio-fertilizers contains a mixture of various inputs in which &lsquo;Organic manure&rsquo; is the main input
            since it constitutes 50% of the final product.</p>

        <p>Since the two products i.e. Phosphate Solubilising Bacteria and Potassium mobilising Bio-fertilizers contains
            a mixture of various inputs, reference will be required to be made to Rule 3(b) of the General Rules for the
            interpretation of Customs Tariff, in order to sort out the matter. As per Rule 3(b), mixtures, composite
            goods consisting of different materials or made up of different components, and goods put up in sets for
            retail sale, which cannot be classified by reference to (a), shall be classified as if they consisted of the
            material or component which gives them their essential character, in so far as the criterion is applicable.
            Since the two products are mixtures that constitute of 50% organic manures, it can be construed that organic
            manure is the main component in the mixture and therefore, it is &lsquo;Organic manure&rsquo; which gives
            the mixture it&rsquo;s essential character - in light of Rule 3(b) of the General Rules for the
            interpretation of Customs Tariff, the products of the appellant would be rightly classifiable under the
            Chapter Sub-heading applicable to &lsquo;Organic manure&rsquo; only.</p>

        <p>The appellant has accepted the classification of their product &lsquo;Organic manure&rsquo; as given in the
            impugned order of Advance Ruling. Hence it can be concluded that the two products namely Phosphate
            Solubilising Bacteria and Potassium mobilising Bio-fertilizers manufactured and supplied by the appellant
            are classifiable under Chapter subheading No.31059090 of the First Schedule to the Customs Tariff Act,
            1975(51 of 1975) and liable to GST at 5% in terms of Sl.No.182D of Schedule-I of Notification
            No.01/2017-Central Tax(Rate) dated 28.06.2017 (as amended from time to time). </p>

        <p>The two products namely &lsquo;Phosphate Solubilising Bacteria&rsquo; and &lsquo;Potassium mobilising
            Bio-fertilizers&rsquo; manufactured and supplied by the appellant M/s. G.B. Agro Industries, Bharuch are
            classifiable under Chapter sub-heading No.31059090 of the First Schedule to the Customs Tariff Act, 1975(51
            of 1975) and liable to GST at 5% in terms of Sl.No.182D of Schedule-I of Notification No.01/2017-Central
            Tax(Rate) dated 28.06.2017 - the classification of the products is entirely based on the composition of
            inputs as given by the appellant and any alteration/change in the composition of the inputs would also
            result in alteration of the classification of the aforementioned products.</p>
    </span>

    </p>


    <p>
        <div align="justify"><strong>Judgment / Order</strong></div>
    </p>
    <p>
        <div align="justify">
            <p align="center" style="text-align:center"><strong>J. P. GUPTA AND SEEMA ARORA, MEMBER</strong></p>

            <p><strong>Present for the appellant : Shree Avinash Poddar</strong></p>

            <p>The appellant M/s. G.B.Agro Industries, Plot No.1723, GIDC Panoli, Ankleshwar, Bharuch-394116 is involved
                in the manufacture of different type of fertilizers such as chemical fertilizers, organic fertilizers
                and bio-fertilizers. The appellant has submitted that they distribute their products through the network
                of Agro dealers and looking at the importance of market needs, they thought it appropriate to enlarge
                their market base keeping the potential of different areas in mind and have many Agro dealers and
                distributors in Maharashtra, Gujarat, Madhya Pradesh and Rajasthan. The appellant had filed an
                application on 15.08.2020 before the Gujarat Authority of Advance Ruling (hereinafter referred to as
                GAAR) seeking Advance Ruling on the classification of Organic Fertilizers, Bio-fertilizers, Nitrogeneous
                mixture fertilizers and Mixture fertilizers. <strong><em>GAAR vide order No. GUJ/GAAR/R/71/2020 dated
                        17.09.2020</em></strong> classified the aforementioned products as under:</p>

            <p style="margin-left:48px"><em>(1) &lsquo;Organic manure&rsquo; was classified under Chapter sub-heading
                    No.31059090 on which GST liability was 5% (2.5%SGST + 2.5%CGST).</em></p>

            <p style="margin-left:48px"><em>(2) &lsquo;Bio-fertilizers&rsquo; were classified under Chapter sub-heading
                    No.30029030 on which GST liability was 12% (6%SGST + 6%CGST).</em></p>

            <p style="margin-left:48px"><em>(3) &lsquo;Nitrogeneous mixture fertilizers&rsquo; were classified under
                    Chapter subheading No.31029090 on which GST liability was 5% (2.5%SGST + 2.5%CGST).</em></p>

            <p style="margin-left:48px"><em>(4) &lsquo;Mixture of fertilizers&rsquo; was classified under Chapter
                    sub-heading No.31059090 on which GST liability was 5% (2.5%SGST + 2.5%CGST).</em></p>

            <p>2. Aggrieved with the aforesaid ruling, the appellant has filed the present appeal on 28.10.2020
                challenging the classification of Bio-fertilizers given as per the Advance Ruling of GAAR. However, the
                appellant has not challenged the Advance Ruling given in respect of the products Organic manure,
                Nitrogeneous mixture fertilizers and Mixture of fertilizers. The appellant has submitted that as per the
                Fertilizer Control Order 1985, Bio-fertilizer means the product containing carrier based (solid or
                liquid) living microorganisms which are agriculturally useful in terms of nitrogen fixation, phosphorus
                solubilisation or nutrient mobilization, to increase the productivity of soil or crop.</p>

            <p>3. As per the appellant, the different types of Bio-fertilizers are Rhizobium, Azatobacter,
                Azospirillium, Phosphate Solubilising Bacteria, Myccorhizal Biofertilizers, Potassium Mobilizing
                Bio-fertilizers, Acetobacter, Carrier Based Consortia and Phosphate Solubilising Fungal Bio-fertilizer.
                The other organic materials contained therein are Lignite/coal powder, organic manure, bone meal, amino
                acids, bio-fulvic, potassium humate and rock phosphate and the carrier materials are bentonite, dolomite
                powder and gypsum.</p>

            <p>4. The appellant has submitted the manufacturing process of Granulated Bio-fertilizer as under:</p>

            <p style="margin-left:48px"><em>(i) Main parts of the production equipment are feeding hopper, granulator
                    drum, drier drum, cooler drum, vibrating screen, coating drum and packaging machine.</em></p>

            <p style="margin-left:48px"><em>(ii) <strong><u>Fertilizer Production Line Main Components</u>:</strong> The
                    whole fertilizer machinery in the fertilizer production line includes the following machines:
                    fertilizer feeding hopper&gt; fertilizer crushing machine&gt; rotary drum granulator&gt; rotary drum
                    drying machine&gt; rotary drum cooling machine&gt; rotary screening machine&gt; coating machine &gt;
                    packaging.</em></p>

            <p style="margin-left:48px"><em>(iii) <strong><u>Bio-Fertilizer Production Line Working
                            Flowchart</u>:</strong> According to the compatibility and crossability, raw materials in
                    different percentage composition are taken so different fertilizers can be manufactured as per
                    requirement applicable for different requirements of soils and crops.</em></p>

            <p style="margin-left:96px"><strong><em><u>1. Feeding Hopper:</u></em></strong><em> The different types of
                    career materials are feeded into hopper. Then according to the technical requirements, the raw
                    materials in that particular composition are sent from the feeding hopper to the crushing
                    process.</em></p>

            <p style="margin-left:96px"><strong><em><u>2. Crushing Process:</u></em></strong><em> The lump materials
                    should be grinded before the granulating process. But the crushing process can be left out when the
                    material is fine enough. Then the conveying belt sends the materials to granulation drum.</em></p>

            <p style="margin-left:96px"><strong><em><u>3. Granulator Drum:</u></em></strong><em> During granulating,
                    there is a water pump to offer water and makes fertilizer particles forming easily. The solid
                    fertilizer powder after granulating will rise by the rotation of the cylinder and scroll down under
                    the effect of gravity. After several times repetition of the same rotation, fertilizer materials
                    gradually form. Next the conveying belt sends the materials to rotary drum drying machine and
                    cooling machine.</em></p>

            <p style="margin-left:96px"><strong><em><u>4. Drier Drum:</u></em></strong><em> In this process, drier drum
                    rotates and there is coal furnace to supply hot air to drying machine so as to increase the strength
                    of granules after granulation from granulator drum. After drying, the conveyor belt sends the
                    granules to cooling drum.</em></p>

            <p style="margin-left:96px"><strong><em><u>5. Cooler Drum:</u></em></strong><em> In this process, the cooler
                    drum rotates and there are draught fans to supply normal air so as to further increase the strength
                    of granules. After cooling, the conveyor belt sends the granules to vibrating screen.</em></p>

            <p style="margin-left:96px"><strong><em><u>6. Screening Process:</u></em></strong><em> In the process of
                    screening, the qualified materials can be sent to packaging machine by conveyor, while others are
                    conveyed back to crusher or granulator to be reprocessed.</em></p>

            <p style="margin-left:96px"><strong><em><u>7. Coating:</u></em></strong><em> After granules are
                    manufactured, they do coating of different types of Bio-fertilizers as per FCO, 1985 guidelines. In
                    process of coating, cylindrical drum rotates and granules are feeded and spray of required
                    Bio-fertilizer as per requirement is done.</em></p>

            <p>5. The appellant has submitted that looking to the above facts, question arises in their mind as to how
                their product &lsquo;Bio-fertilizers&rsquo; can be classified under chapter heading 30029030 and taxable
                under GST@12% when Chapter heading 3002 deals with pharmaceutical products whereas the bio-fertilizers
                manufactured by them are used for agricultural purpose. The appellant has submitted the grounds of
                appeal as under:</p>

            <p style="margin-left:48px"><em>(i) GAAR has searched the term &lsquo;Bio Fertilizers&rsquo; from Vikaspedia
                    in which the definition is as stated under:</em></p>

            <p style="margin-left:96px"><em>&ldquo;In nature, there are a number of useful soil microorganisms which can
                    help plants to absorb nutrients. Their utility can be enhanced with human intervention by selecting
                    efficient organisms, culturing them and adding them to soil directly or through seeds. The cultured
                    micro organisms packed in some carrier material for easy application in the field are called
                    bio-fertilizers. Thus the critical input in Bio-fertilizers is the micro organisms.&rdquo;</em></p>

            <p style="margin-left:48px"><em>The learned authority relied on the above definition found on Vikaspedia and
                    has thus classified Bio-fertilizers under Chapter Heading 30029030 which covers &lsquo;cultures of
                    microorganisms(excluding yeasts).</em></p>

            <p style="margin-left:48px"><em>(ii) Chapter 30 is for Pharmaceutical products and sub-heading 3002 reads as
                    under:</em></p>

            <p style="margin-left:48px"><strong><em>&ldquo;Human Blood;</em></strong><em> Animal Blood prepared for
                    therapeutic, prophylactic or diagnostic uses; Antisera, Other blood fractions and immunological
                    products, whether or not modified or obtained by means of Biotechnological processes; vaccines,
                    toxins, <u>cultures of micro organisms (excluding yeasts)</u> and similar products.&rdquo;</em></p>

            <p style="margin-left:48px"><em>The main purpose of Bio fertilizers manufactured by the appellant is
                    agricultural. This product is useful in terms of nitrogen fixation, phosphorus solubilisation or
                    nutrient mobilization, to increase the productivity of soil or crop. Thus, classification of same
                    under the chapter which relates to pharmaceutical products is not valid.</em></p>

            <p style="margin-left:48px"><em>(iii) Further, along with culture of micro organisms, the composition of
                    biofertilizers includes-</em></p>

            <p style="margin-left:96px"><em>a. Organic and other materials such as organic manure, coal powder, bone
                    meal, bio-fulvic acids, amino acids, potassium humate, rock phosphate.</em></p>

            <p style="margin-left:96px"><em>b. Carrier material such as gypsum, bentonite and dolomite.</em></p>

            <p style="margin-left:96px"><em>c. Bio-fertilizers(Micro organisms).</em></p>

            <p style="margin-left:48px"><em>Appellant submits that micro organisms are used along with various other
                    components and are not sold as micro organisms for pharmaceutical use and therefore, their
                    classification under chapter heading 30029030 is not valid.</em></p>

            <p style="margin-left:48px"><em>(iv) The Bio-fertilizers manufactured by the appellant are a mixture of
                    various components used by buyers to increase the productivity of soil or crop. It has no purpose as
                    a pharmaceutical product and thus it&rsquo;s classification under HSN 3002 is not valid and should
                    be covered under chapter heading 3101.</em></p>

            <p style="margin-left:48px"><em>(v) Bio-fertilizers are also permitted to be used for Organic farming. The
                    key elements of components are as follows:</em></p>

            <table align="center" cellspacing="0" class="MsoTableGrid" style="border-collapse:collapse; border:none">
                <tbody>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>Component </em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>Key Element</em></strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Organic manure </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Carbon, Nitrogen, Phosphorous and Potash.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Coal powder </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Organic carbon.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Bone meal </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Phosphorus, organic carbon and calcium.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Bio-fulvic </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Potassium Nitrogen and Potassium.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Amino acids </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Carbon, Hydrogen, Oxygen and Nitrogen.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Potassium humate </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Potassium.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Rock phosphate </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Phosphorous.</em></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p style="margin-left:48px"><em>(vi) The Regional Director, Regional Centre of Organic Farming published a
                    booklet on &ldquo;Organic Manures&rdquo; in January, 2005 wherein it was mentioned that carbon
                    present in soil is in form of organic manure. The components used for manufacturing of Bio
                    fertilizers are rich in carbon content. Thus, it can be used as organic manure and therefore, can be
                    used in agriculture. Sr.No. of Part II i.e. microbiological of Table 13 on page 42 of the published
                    Booklet permits the use of Bio fertilizer in Organic farming. Copy of relevant extract of the
                    booklet has been submitted. Further, the intention of the manufacturer and components used in
                    manufacture are not directed towards manufacturing a pharmaceutical product and therefore
                    classification under chapter sub heading 30029030 is not valid.</em></p>

            <p style="margin-left:48px"><em>(vii) There are various judicial precedents as well in this regard, wherein
                    the said view has been upheld:</em></p>

            <p style="margin-left:96px"><em>a. <strong><u>Rajasthan Authority for Advance Ruling in Rhizo Organic 2018
                            (14) GSTL.600(AAR-GST)-</u> </strong>Bio-fertilizers or Organic fertilizer is classifiable
                    under Tariff Heading 3101 and when it is put up in Unit container and bearing a brand name, it would
                    be covered under Schedule-I of rate of GST on goods attracting/attract NIL rate of duty but when
                    Bio-fertilizer is put up in Unit container and bearing a brand name, it would be taxable under
                    GST@5%. Copy of order is submitted.</em></p>

            <p style="margin-left:96px"><strong><em><u>b. Uttarakhand Authority for Advance Ruling in M/s.Elefo Biotech
                            Pvt.ltd. -15/2018-19:</u></em></strong><em> Product in question was &lsquo;Anaerobic
                    Microbial Inoculums(AMI)&rdquo; which is made from culturing micro organisms in cattle dung. It is
                    used in Bio-Toilets in Railway coaches and as organic manure. AAR ruled that it is nothing but
                    organic manure which is generally used in Bio-toilets and therefore, classified under Chapter
                    heading 3101 of the GST Tariff and accordingly attracts GST@5%. Copy of order is submitted.</em></p>

            <p style="margin-left:48px"><em>(viii) As per General Industry Practice and as per ikhedut.gujarat.gov.in,
                    companies like GSFC Agrotech Limited, Agriland Biotech limited and Bharat Biogas Energy limited are
                    also dealing in Bio-fertilizers under Chapter heading 3101 at applicable GST @5%, copy of which has
                    been submitted.</em></p>

            <p>6. The appellant vide additional submission dated 30.04.2021 has submitted as under:</p>

            <p style="margin-left:48px"><em>(i) the composition of the inputs in their product
                    &lsquo;Bio-fertilizer&rsquo; is as under:</em></p>

            <table align="center" cellspacing="0" class="MsoTableGrid" style="border-collapse:collapse; border:none">
                <tbody>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>Sr.No. </em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>Raw material </em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>Percentage</em></strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>1.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Organic manure</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>50%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Lignite/Coal powder</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>3.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Bio-Fulvic</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>4.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Potassium Humate</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>1%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Rock Phosphate Mineral</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>6.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Bio Culture</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>7.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Ball Clay Mineral Powder</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>30%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>8.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Gypsum(Carrier Material)</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>15%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>9.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Dolomite Mineral(Carrier Material)</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Total input</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>115%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Normal wastage</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>15%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Output i.e. Bio-fertilizers</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>100%</em></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p style="margin-left:48px"><em>The appellant has stated that from the total input of 115%, normally 15% is
                    waste, and therefore usually for 1 quantity of output, 115% raw materials are used. The appellant
                    has also submitted that the main ingredient in the output is organic manure, the main source of
                    which is animal waste. They have also submitted that they use organic manure as main ingredient
                    because their intention is to sell the Bio-fertilizers to the agriculturists for agricultural
                    purpose only.</em></p>

            <p style="margin-left:48px"><em>(ii) The appellant has relied on the Advance Rulings of <strong>(a)
                        Rajasthan Authority for Advance Ruling in Rhizo Organic-2018 (14) GSTL. 600 (AAR-GST) and (b)
                        Uttarakhand Authority for Advance Ruling in M/s. Elefo Biotech Pvt. Ltd. -15/2018-19</strong> to
                    support their contention stating their final products are sold for agricultural purpose only and
                    therefore the above rulings support their contention and therefore bio-fertilizers will be covered
                    under Chapter Heading 3101.</em></p>

            <p style="margin-left:48px"><em>(iii) The manufacturing and coating process is done on above mentioned raw
                    materials in accordance with Fertilizers Control order, 1985 and depending on the kind of final
                    output, the composition varies. However, organic manure is always the main ingredient. The different
                    types of bio-fertilizers that can be manufactured are Phosphate Solubilising Bacteria, Potassium
                    Mobilizing Biofertilizers Rhizobium, Azatobacter, Azospirillium, Myccorhizal Biofertilizers, Zinc
                    solubilising Bio-fertilizers, Acetobacter, Carrier Based Consortia, Phosphate Solubilising Fungal
                    Bio-fertilizer and Liquid Consortia. The appellant has submitted that presently, they are producing
                    Phosphate Solubilising Bacteria and Potassium mobilising Bio-fertilizers and the rest of the
                    products can be manufactured as and when there is demand in the market and due to it&rsquo;s limited
                    usage purpose i.e. agriculture use, end consumers are agriculturists.</em></p>

            <p style="margin-left:48px"><em>(iv) The Bio-fertilizers are manufactured as per Fertilizer Control
                    Order(FCO), 1985 guidelines and the objective and aim of the FCO is to ensure adequate availability
                    of right quality of fertilizers at right time and at right price to farmer. Part-A of Schedule-III
                    of the FCO deals with the specifications of the Bio-fertilizers i.e. specification of contents and
                    these specifications are strictly followed by the appellant. Relevant extract of FCO i.e. Page 177
                    to 182 has been attached.</em></p>

            <p style="margin-left:48px"><em>(v) As per FCO, it is mandatory condition to hold a license which permits
                    manufacture and sale of the product as bio-fertilizers, that the appellant has obtained the license
                    from the Deputy Director of Agriculture(Ext.), Bharuch and the products under question are listed as
                    Bio-fertilisers in the license(copy of same submitted). Also, dealer who purchases Bio-fertilizer
                    from appellant are also required to hold a License in order to sell the product to farmers as
                    Biofertilizers. Copies of licenses held by few purchasers is also submitted.</em></p>

            <p style="margin-left:48px"><em>(vi) The aim and objective of issuing FCO is welfare of farmers and as
                    appellant is following the specifications given in the FCO, it is clear that they are manufacturing
                    a product intended to be used by the farmers. Further, the dealers who buy the Bio-fertilizers from
                    the appellant also hold a license for sale of Bio-fertilizers and therefore it can be said that the
                    goods are manufactured with intention of use for agriculture only.</em></p>

            <p style="margin-left:48px"><em>(vii) In order to substantiate that the products manufactured by them are
                    for agricultural use only, the appellant have submitted a Tax Invoice of sale of Bio-fertilizers to
                    one of the Dealers wherein Point No.5 in Declaration given on Tax Invoice clearly states &lsquo;The
                    above products are for agriculture use only&rsquo;.</em></p>

            <p style="margin-left:48px"><em>(viii) The appellant has stated that &lsquo;For Agricultural Use only&rsquo;
                    is specifically mentioned on the packaging or containers of the Biofertilizers. Copy of Packaging of
                    Bio-fertilizers is also submitted.</em></p>

            <p>7. The appellant has concluded his submission by stating that the Biofertilizers manufactured by them are
                intended to be sold to farmers for Agricultural use only and thus should be classified under chapter
                heading 3101 i.e. All goods i.e. animal or vegetable fertilizers or organic fertilizers put up in unit
                containers and bearing a brand name.</p>

            <p><strong><u>FINDINGS :-</u></strong></p>

            <p>8. We have considered the submissions made by the appellant in the appeal filed by them, their
                contentions during the course of personal hearing as well as evidences available on record. We have also
                gone through the Ruling given by the GAAR.</p>

            <p>9. The Advance Ruling was sought for by the appellant for appropriate classification and applicable rate
                of Goods and Services Tax for their products Organic Fertilizers, Bio-fertilizers, Nitrogeneous mixture
                fertilizers and Mixture fertilizers.&rsquo;. <strong><em>GAAR vide Advance Ruling No. GUJ/GAAR/R/71/2020
                        dated 17.09.2020</em></strong> ruled that</p>

            <p style="margin-left:48px"><em>(i) &lsquo;Organic manure&rsquo; was classified under Chapter subheading
                    No.31059090 on which GST liability was 5% (2.5%SGST + 2.5%CGST). </em></p>

            <p style="margin-left:48px"><em>(ii) &lsquo;Bio-fertilizers&rsquo; were classified under Chapter sub-heading
                    No.30029030 on which GST liability was 12% (6%SGST + 6%CGST). </em></p>

            <p style="margin-left:48px"><em>(iii) &lsquo;Nitrogeneous mixture fertilizers&rsquo; were classified under
                    Chapter sub-heading No.31029090 on which GST liability was 5% (2.5%SGST + 2.5%CGST). </em></p>

            <p style="margin-left:48px"><em>(iv) &lsquo;Mixture of fertilizers&rsquo; was classified under Chapter
                    sub-heading No.31059090 on which GST liability was 5% (2.5%SGST + 2.5%CGST). The appellant has filed
                    the present appeal challenging the classification of Biofertilizers as per the aforementioned
                    Advance Ruling of GAAR but have not challenged the Advance Ruling given in respect of the products
                    Organic manure, Nitrogeneous mixture fertilizers and Mixture of fertilizers. Therefore, the issue
                    involved in this case is limited to the proper classification of the product
                    &lsquo;Biofertilizer&rsquo; and the applicable rate of Goods and Services Tax on the said
                    product.</em></p>

            <p>10. The appellant has submitted that their product &lsquo;Bio-fertilizers are classifiable under Chapter
                Heading 3101 and stated that it is used for agriculture purpose and helps in increasing the productivity
                of the soil or crop. The appellant has also contended that the Advance Ruling Authority has relied on
                the definition of &lsquo;Bio-fertilizer&rsquo; as given in Vikaspedia and based on this definition, had
                classified their aforementioned product under Chapter Heading 30029030. So the main issue to be decided
                is whether the product &lsquo;Bio-fertilizer&rsquo;, manufactured and supplied by the appellant falls
                under Chapter Heading 3101 or 3002 or some other Chapter heading under the Customs Tariff Act, 1975(51
                of 1975).</p>

            <p>11. To begin with, a reference is required to be made to the definitions of biofertilizers. Definition of
                Bio-fertilizers as per Wikipedia and Vikaspedia are as under:</p>

            <ul>
                <li style="margin-left:8px"><em>As per Wikipedia, biofertilisers are defined as a substance which
                        contains living micro-organisms which, when applied to seeds, plant surfaces, or soil, colonize
                        the rhizosphere or the interior of the plant and promotes growth by increasing the supply or
                        availability of primary nutrients to the host plant.</em></li>
                <li style="margin-left:8px"><em>Vikaspedia defines biofertilisers as under: In nature, there are a
                        number of useful soil micro organisms which can help plants to absorb nutrients. Their utility
                        can be enhanced with human intervention by selecting efficient organisms, culturing them and
                        adding them to soil directly or through seeds. The cultured micro organisms packed in some
                        carrier material for easy application in the field are called bio-fertilisers. Thus the critical
                        input in Biofertilisers is the microorganisms.</em></li>
            </ul>

            <p>12. The appellant has submitted that as per the Fertilizer Control Order 1985, Bio-Fertilizer means the
                product containing carrier based (solid or liquid) living microorganisms which are agriculturally useful
                in terms of nitrogen fixation, phosphorus solubilisation or nutrient mobilization, to increase the
                productivity of soil or crop.</p>

            <p>13. As per Vikaspedia, benefits/uses of Bio-fertilisers are as under:</p>

            <p>Bio-fertilisers are living microorganisms of bacterial, fungal and algal origin. Their mode of action
                differs and can be applied alone or in combination.</p>

            <ul>
                <li style="margin-left:8px"><em>Biofertilizers fix atmospheric nitrogen in the soil and root nodules of
                        legume crops and make it available to the plant.</em></li>
                <li style="margin-left:8px"><em>They solubilise the insoluble forms of phosphates like tricalcium, iron
                        and aluminium phosphates into available forms.</em></li>
                <li style="margin-left:8px"><em>They scavenge phosphate from soil layers.</em></li>
                <li style="margin-left:8px"><em>They produce hormones and anti metabolites which promote root
                        growth.</em></li>
                <li style="margin-left:8px"><em>They decompose organic matter and help in mineralization in soil.</em>
                </li>
                <li style="margin-left:8px"><em>When applied to seed or soil, biofertilizers increase the availability
                        of nutrients and improve the yield by 10 to 25% without adversely affecting the soil and
                        environment.</em></li>
            </ul>

            <p>14. As per the submission of the appellant, the Bio-fertilizers manufactured and supplied by them are a
                mixture of various components used by buyers to increase the productivity of soil or crop, that it has
                no purpose as a pharmaceutical product and thus it&rsquo;s classification under HSN 3002 is not valid
                and should be covered under chapter heading 3101. The manufacturing process of the
                &lsquo;Bio-fertilizers&rsquo; manufactured by them is described at para-4 above. The appellant has also
                stated that the main purpose of Bio fertilizers manufactured by them is agricultural and is useful in
                terms of nitrogen fixation, phosphorus solubilisation or nutrient mobilization, to increase the
                productivity of soil or crop; that the micro organisms are used along with various other components and
                are not sold as micro organisms for pharmaceutical use and therefore, their classification under chapter
                heading 30029030 is not valid. The appellant has further submitted that the different types of
                bio-fertilizers that can be manufactured are Phosphate Solubilising Bacteria, Potassium Mobilizing
                Biofertilizers Rhizobium, Azatobacter, Azospirillium, Myccorhizal Bio-fertilizers, Zinc solubilising
                Bio-fertilizers, Acetobacter, Carrier Based Consortia, Phosphate Solubilising Fungal Bio-fertilizer and
                Liquid Consortia; that presently, they are producing Phosphate Solubilising Bacteria and Potassium
                mobilising Biofertilizers and the rest of the products can be manufactured as and when there is demand
                in the market and due to it&rsquo;s limited usage purpose i.e. agriculture use, end consumers are
                agriculturists. The appellant has submitted the composition of the inputs in their product
                &lsquo;Bio-fertilizer&rsquo; as under:</p>

            <table align="center" cellspacing="0" class="MsoTableGrid" style="border-collapse:collapse; border:none">
                <tbody>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>Sr.No.</em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>Raw material</em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>Percentage</em></strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>1.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Organic manure</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>50%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Lignite/Coal powder</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>3.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Bio-Fulvic</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>4.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Potassium Humate</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>1%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Rock Phosphate Mineral</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>6.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Bio Culture</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>2%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>7.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Ball Clay Mineral Powder</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>30%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>8.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Gypsum(Carrier Material)</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>15%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>9.</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Dolomite Mineral(Carrier Material)</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>5%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Total input</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>115%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Normal wastage</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>15%</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center">&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>Output i.e. Bio-fertilizers</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>100%</em></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>15. The appellant has also stated that from the total input of 115%, normally 15% is waste, and therefore
                usually for 1 quantity of output, 115% raw materials are used. The appellant has also submitted that the
                main ingredient in the output is organic manure, the main source of which is animal waste. They have
                also submitted that they use organic manure as main ingredient because their intention is to sell the
                Bio-fertilizers to the agriculturists for agricultural purpose only. It is also observed that the
                aforementioned composition of inputs (percentage wise) for &lsquo;Bio-fertilizers&rsquo; (which they
                have submitted now) was never brought to the notice of the Advance Ruling Authorities by the appellant
                but has been submitted only after the hearing of the appeal filed by them, which was held on 15.04.2021.
            </p>

            <p>16. From the above submission of the appellant, especially the composition of the inputs contained in
                their products i.e. &lsquo;Bio-fertilizers&rsquo; and comparing the same to the definitions of
                &lsquo;Bio-fertilizers&rsquo; mentioned in paras-11 to 13 above, it does not appear to meet the criteria
                of &lsquo;bio-fertilizer&rsquo; particularly because &lsquo;Organic manure&rsquo; (main source of which
                is animal waste) is a major input constituting 50% of the mixture whereas Bio culture contained therein
                is only 2%. Further, the appellant themselves have submitted that they are presently manufacturing only
                two types of &lsquo;Bio-fertilizers&rsquo; namely Phosphate Solubilising Bacteria and Potassium
                mobilising Bio-fertilizers. Hence, it can be presumed that the composition of inputs submitted by them
                pertains to these two products only and therefore the classification to be decided is in respect of
                these two products only. The appellant has also submitted that the main source of &lsquo;Organic
                manure&rsquo; is animal waste and that the key elements contained therein are carbon, nitrogen,
                phosphorus and potash. We, therefore, find, that in the instant case, the aforementioned two products
                i.e. Phosphate Solubilising Bacteria and Potassium mobilising Bio-fertilizers contains a mixture of
                various inputs in which &lsquo;Organic manure&rsquo; is the main input since it constitutes 50% of the
                final product. Therefore, in order to clarify the matter, we will be required to refer to the General
                Rules for the interpretation of Customs Tariff which reads as under:</p>

            <p style="margin-left:48px"><em>Classification of goods in this Schedule shall be governed by the following
                    principles:</em></p>

            <p style="margin-left:48px"><em>The titles of Sections, Chapters and Sub-Chapters are provided for ease of
                    reference only; for legal purposes, classification shall be determined according to the terms of the
                    headings and any relative Section or Chapter Notes and, provided subheadings or Notes do not
                    otherwise require, according to the following provisions:</em></p>

            <p style="margin-left:96px"><em>2. (a) Any reference in a heading to an article shall be taken to include a
                    reference to that article incomplete or unfinished article provided that, as presented, the
                    incomplete or unfinished article has the essential character of the complete or finished article. It
                    shall also be taken to include a reference to that article complete or finished (or falling to be
                    classified as complete or finished by virtue of this rule), presented unassembled or
                    disassembled.</em></p>

            <p style="margin-left:96px"><em>b) Any reference in a heading to a material or substance shall be taken to
                    include a reference to mixtures or combinations of that material or substance with other materials
                    or substances. Any reference to goods of a given material or substance shall be taken to include a
                    reference to goods consisting wholly or partly of such material or substance. The classification of
                    goods consisting of more than one material or substance shall be according to the principles of rule
                    3.</em></p>

            <p style="margin-left:48px"><em>&ldquo;3. When by application of Rule 2(b) or for any other reason, goods
                    are, prima facie, classifiable under two or more headings, classification shall be effected as
                    follows:</em></p>

            <p style="margin-left:96px"><em>(a) The heading which provides the most specific description shall be
                    preferred to headings providing a more general description. However, when two or more headings each
                    refer to part only of the materials or substances contained in mixed or composite goods or to part
                    only of the items in a set put up for retail sale, those headings are to be regarded as equally
                    specific in relation to those goods, even if one of them gives a more complete or precise
                    description of the goods.</em></p>

            <p style="margin-left:96px"><em>(b) Mixtures, composite goods consisting of different materials or made up
                    of different components, and goods put up in sets for retail sale, which cannot be classified by
                    reference to (a), shall be classified as if they consisted of the material or component which gives
                    them their essential character, in so far as the criterion is applicable.</em></p>

            <p style="margin-left:96px"><em>(c) When goods cannot be classified by reference to (a) or (b), they shall
                    be classified under the heading which occurs last in numerical order among those which equally merit
                    consideration.&rdquo;</em></p>

            <p>17. Since the aforementioned two products i.e. Phosphate Solubilising Bacteria and Potassium mobilising
                Bio-fertilizers contains a mixture of various inputs, reference will be required to be made to Rule 3(b)
                of the General Rules for the interpretation of Customs Tariff, in order to sort out the matter. As per
                Rule 3(b) above, mixtures, composite goods consisting of different materials or made up of different
                components, and goods put up in sets for retail sale, which cannot be classified by reference to (a),
                shall be classified as if they consisted of the material or component which gives them their essential
                character, in so far as the criterion is applicable. Since the two products, as discussed earlier are
                mixtures that constitute of 50% organic manures, it can be construed that organic manure is the main
                component in the mixture and therefore, it is &lsquo;Organic manure&rsquo; which gives the mixture
                it&rsquo;s essential character. Therefore, in light of Rule 3(b) of the General Rules for the
                interpretation of Customs Tariff, the aforementioned products of the appellant would be rightly
                classifiable under the Chapter Sub-heading applicable to &lsquo;Organic manure&rsquo; only.</p>

            <p>18. We also find that the impugned order of Advance Ruling of GAAR has already decided the classification
                of &lsquo;Organic manure&rsquo; since the appellant had sought Advance Ruling in respect of the
                classification of their product &lsquo;Organic manure&rsquo; vide their application for Advance Ruling
                dated 12.03.2019(revised on 15.08.2020). It therefore follows, that the contents of their product
                &lsquo;Organic manure&rsquo; (for which they had sought classification) as well as that of the input
                &lsquo;Organic manure&rsquo; (which forms a major constituent of the products i.e. Phosphate
                Solubilising Bacteria and Potassium mobilizing Biofertilizer), will obviously be the same. We also find
                that the Gujarat Authority for Advance Ruling (GAAR) vide the impugned order dated 17.09.2020 had
                classified the product &lsquo;Organic manure&rsquo; of the appellant under Chapter sub-heading
                No.31059090 of the First Schedule to the Customs Tariff Act, 1975(51 of 1975) which was liable to GST at
                5% in terms of Sl.No.182D of Schedule-I of Notification No.01/2017-Central Tax(Rate) dated 28.06.2017 as
                amended on the following grounds:</p>

            <p style="margin-left:48px"><em>(i) Chapter heading 3101 00 which reads as &lsquo;Animal or vegetable
                    fertilisers, whether or not mixed together or chemically treated; fertilisers produced by the mixing
                    or chemical treatment of animal or vegetable products&rsquo; clearly indicates that it covers
                    fertilizers produced by mixing or chemical treatment of animal or vegetable products. The
                    ingredients used for manufacture of &lsquo;organic fertilizers&rsquo; as per the applicant are
                    poultry manure, organic ash, compost, cow dung, bone meal, vegetable waste, sulphur powder(mineral),
                    rock phosphate(mineral) and Bentonite(Mineral), Gypsum(for neutralisation), bioculture amino acid,
                    bio-fulvic and potassium humate. Of the said ingredients, poultry manure, organic ash, compost, cow
                    dung, bone meal are within the scope of &lsquo;animal or vegetable products&rsquo; but sulphur
                    powder, rock phosphate, bentonite and gypsum are admittedly minerals whereas potassium humate is a
                    chemically synthesised element which is extracted from brown coal and the process involves alkaline
                    reaction. Bio-fulvic is also commercially known as Bio Potassium fulvate.</em></p>

            <p style="margin-left:48px"><em>(ii) The above indicates that the ingredients viz. Sulphur powder, rock
                    phosphate, bentonite, gypsum, potassium humate and bio-fulvic are certainly not covered under the
                    Animal or vegetable products. For the product to be covered under Chapter head 3101, the product
                    should necessarily be either direct animal or vegetable fertilizers such as manure, whether mixed
                    together and chemically treated or otherwise and those obtained by mixing or chemical treatment of
                    animal or vegetable products. The said interpretation finds support in the technical definition of
                    the term &lsquo;organic fertilizer&rsquo; which reads as</em></p>

            <p style="margin-left:96px"><em>&lsquo;Organic fertilizers are fertilizers derived from animal matter,
                    animal excreta(manure), human excreta and vegetable matter (e.g. compost and crop residues).
                    Naturally occurring organic fertilizers include animal wastes from meat processing, peat, manure,
                    slurry and guano. In contrast, the majority of fertilizers used in commercial farming are extracted
                    from minerals (e.g. phosphate rock) or produced industrially (e.g. ammonia).</em></p>

            <p style="margin-left:48px"><em>(iii) The definition in the trade parlance also clearly indicates that
                    Organic Fertilisers are solely obtained from animal or vegetable matter and no other ingredients are
                    present in them. In the instant case, the composition of the &lsquo;Organic Fertilizers&rsquo; as
                    provided by the applicant reveals that it is a mixture of various elements and as such the same
                    should be examined in light of the fact whether the mixture consists of animal or vegetable products
                    or otherwise. The above analysis of the individual ingredients of the product claimed to be
                    &lsquo;organic fertilizers&rsquo; indicates that the same is derived from a mixture of animal
                    products, vegetable products, minerals and chemically synthesised molecules i.e. the product is not
                    exclusively a mixture of animal or vegetable products and hence cannot be covered under the Chapter
                    Heading 3101 of the first schedule to the Customs Tariff Act.</em></p>

            <p style="margin-left:48px"><em>(iv) The composition of the product contains Amino Acids(Bio-culture amino
                    acids) and the key elements of an amino acid are Carbon(C), Hydrogen(H), Oxygen(O) and Nitrogen(N),
                    although other elements are found in the side chains of certain amino acids, hence presence of
                    nitrogen is visible. Further, it contained potassium humate, hence presence of potassium is also
                    visible. Rock phosphate which is also one of the components of the product is a non-detrital
                    sedimentary rock that contains high amounts of phosphate minerals, hence product also contains
                    phosphate elements. In addition, the product also contains minerals viz. sulphur powder and
                    bentonite. Thus, the product is a mixture of animal or vegetable products, minerals, nitrogen,
                    phosphate and potassium and hence merits classification under Chapter subheading 31059090 which
                    reads as under:</em></p>

            <table align="center" cellspacing="0" class="MsoTableGrid" style="border-collapse:collapse; border:none">
                <tbody>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>3105 </em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p><strong><em>MINERAL OR CHEMICAL FERTILISERS CONTAINING TWO OR THREE OF THE FERTILISING
                                        ELEMENTS NITROGEN, PHOSPHORUS AND POTASSIUM; OTHER FERTILISERS; GOODS OF THIS
                                        CHAPTER IN TABLETS OR SIMILAR FORMS OR IN PACKAGES OF A GROSS WEIGHT NOT
                                        EXCEEDING 10 KG</em></strong></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 10 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Goods of this Chapter in tablets or similar forms or in packages of a gross weight
                                    not exceeding 10 kg.</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 20 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Mineral or chemical fertilisers containing the three fertilising elements nitrogen,
                                    phosphorus and potassium</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 30 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Diammonium hydrogen ortho phosphate(diammonium phosphate) </em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 40 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Ammonium dihydrogen ortho phosphate (monoammonium phosphate) and mixtures thereof
                                    with diammonium hydrogen orthophosphate (diammonium phosphate)</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p>&nbsp;</p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Other mineral or chemical fertilisers containing thetwo fertilising elements
                                    nitrogen and phosphorus :</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 51 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>-- Containing nitrates and phosphates -</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 59 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>-- Other -</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 60 00 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>- Mineral or chemical fertilisers containing the two fertilising elements phosphorus
                                    and potassium </em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 90</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>&nbsp;- Other :</em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>3105 90 10 </em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>--- Mineral or chemical fertilisers containing two fertilizing elements namely
                                    nitrogen and potassium </em></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><strong><em>3105 90 90 </em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><strong><em>--- Other</em></strong></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p style="margin-left:48px"><em>(v) On going through the entry of the above product in the Notification
                    No.01/2017-Central Tax(Rate) dated 28.06.2017(as amended vide Notification No.18/2017-Central
                    Tax(Rate) dated 30.06.2017), it is found that the same appears at Entry No.182D of Schedule-I(on
                    which effective rate of GST is 5%(2.5% SGST + 2.5% CGST) which reads as under:</em></p>

            <table align="center" cellspacing="0" class="MsoTableGrid" style="border-collapse:collapse; border:none">
                <tbody>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>S.No.</em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>Chapter/Heading /Sub-heading/ Tariff
                                        item</em></strong></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:2px solid black; vertical-align:top">
                            <p align="center" style="text-align:center"><strong><em>Description of Goods.</em></strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="border-bottom:2px solid black; border-left:2px solid black; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>182D</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p align="center" style="text-align:center"><em>3105</em></p>
                        </td>
                        <td
                            style="border-bottom:2px solid black; border-left:none; border-right:2px solid black; border-top:none; vertical-align:top">
                            <p><em>Mineral or chemical fertilisers containing two or three of the fertilising elements
                                    nitrogen, phosphorus and potassium; other fertilisers; goods of this Chapter in
                                    tablets or similar forms or in packages of a gross weight not exceeding 10 kg, other
                                    than those which are clearly not to be used as fertilizers.</em></p>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p>19. The appellant has not challenged or appealed against the aforementioned Advance Ruling given by the
                GAAR in the impugned order in respect of their product &lsquo;Organic manure&rsquo;(classified under
                Chapter Heading 31059090). It can therefore be concluded that the appellant has accepted the
                classification of their product &lsquo;Organic manure&rsquo; as given in the impugned order of Advance
                Ruling. Hence we decide and conclude that the aforementioned two products namely Phosphate Solubilising
                Bacteria and Potassium mobilising Bio-fertilizers manufactured and supplied by the appellant are
                classifiable under Chapter subheading No.31059090 of the First Schedule to the Customs Tariff Act,
                1975(51 of 1975) and liable to GST at 5% in terms of Sl.No.182D of Schedule-I of Notification
                No.01/2017-Central Tax(Rate) dated 28.06.2017 (as amended from time to time). We would also like to
                emphasize here that the classification of the aforementioned products is entirely based on the
                composition of inputs as given by the appellant and any alteration/change in the composition of the
                inputs would also result in alteration of the classification of the aforementioned products.</p>

            <p>20. We also find that the appellant has relied on the order bearing No. <strong><em>RAJ/AAR/2018-19/04
                        dated 16.06.2018 of the Rajasthan Advance Ruling Authority in the case of Rhizo Organic as well
                        as Ruling No.18/2018-19 dated 06.02.2019</em></strong> issued by the <strong><em>Uttarakhand
                        Advance Ruling Authority in the case of Elefo Biotech Pvt. ltd</em></strong>. in support of
                their contention that &lsquo;Bio-fertilizers&rsquo; are classifiable under Chapter Heading 3101. In this
                regard, we have to emphasize here that decisions of Advance Ruling Authorities cannot be relied upon by
                the appellant, since, as per the provisions of Section 103 of the CGST Act, 2017, the Advance Ruling
                pronounced by the Advance Ruling Authority or the Appellate Authority shall be binding only on the
                applicant who had sought it in respect of any matter referred to in sub-section(2) of Section 97 for
                Advance Ruling and the concerned officer or the jurisdictional officer in respect of the applicant.</p>

            <p>21. In view of the foregoing, we modify the <strong><em>Advance Ruling No. GUJ/GAAR/R /71/2020 dated
                        17.09.2020</em></strong> issued by the GAAR in respect of &lsquo;Bio-fertilizers&rsquo;, by
                holding that the two products namely &lsquo;Phosphate Solubilising Bacteria&rsquo; and &lsquo;Potassium
                mobilising Bio-fertilizers&rsquo; manufactured and supplied by the appellant M/s. G.B. Agro Industries,
                Bharuch are classifiable under Chapter sub-heading No.31059090 of the First Schedule to the Customs
                Tariff Act, 1975(51 of 1975) and liable to GST at 5% in terms of Sl.No.182D of Schedule-I of
                Notification No.01/2017-Central Tax(Rate) dated 28.06.2017 (as amended from time to time) for the
                reasons discussed hereinabove. Also, the classification of the aforementioned products is entirely based
                on the composition of inputs as given by the appellant and any alteration/change in the composition of
                the inputs would also result in alteration of the classification of the aforementioned products.</p>
        </div>
    </p>


    <hr>
    <p style="page-break-before:always;"></p>

    <p><strong>Citations:</strong> in 2021 (10) TMI 59 - APPELLATE AUTHORITY FOR ADVANCE RULING, GUJARAT</p>
    <p>
        <ol>
            <li><a href="/visitor/Detail_Case_Laws.asp?ID=402951">2021 (1) TMI 543 - AUTHORITY FOR ADVANCE RULING,
                    GUJARAT</a></li>
            <li><a href="/visitor/Detail_Case_Laws.asp?ID=376818">2019 (3) TMI 839 - AUTHORITY FOR ADVANCE RULINGS,
                    UTTARAKHAND</a></li>
            <li><a href="/visitor/Detail_Case_Laws.asp?ID=363657">2018 (7) TMI 965 - AUTHORITY FOR ADVANCE RULINGS,
                    RAJASTHAN</a></li>
        </ol>
    </p>



</body>

</html>
<script type="text/javascript">
    var _gaq = _gaq || [];
    _gaq.push(['_setAccount', 'UA-4454006-1']);
    _gaq.push(['_trackPageview']);
    (function () {
        var ga = document.createElement('script');
        ga.type = 'text/javascript';
        ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') +
            '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);
    })();
</script>`;